var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperatorsblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_2",
    "data-name": "Color 2",
    transform: "translate(0 -0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M10.4,14a.79.79,0,0,1-.8-.778,3.95,3.95,0,0,0-4-3.889,3.95,3.95,0,0,0-4,3.889A.79.79,0,0,1,.8,14a.79.79,0,0,1-.8-.778A5.53,5.53,0,0,1,5.6,7.778,5.646,5.646,0,0,1,9.552,9.369,4.043,4.043,0,0,1,12,8.555a3.95,3.95,0,0,1,4,3.889.8.8,0,0,1-1.6,0A2.37,2.37,0,0,0,12,10.111a2.445,2.445,0,0,0-1.484.5,5.341,5.341,0,0,1,.684,2.606A.79.79,0,0,1,10.4,14ZM12,7.778A2.37,2.37,0,0,1,9.6,5.444a2.4,2.4,0,0,1,4.8,0A2.37,2.37,0,0,1,12,7.778Zm0-3.111a.778.778,0,1,0,.8.778A.79.79,0,0,0,12,4.666ZM5.6,6.223A3.16,3.16,0,0,1,2.4,3.111,3.16,3.16,0,0,1,5.6,0,3.16,3.16,0,0,1,8.8,3.111,3.16,3.16,0,0,1,5.6,6.223Zm0-4.667A1.58,1.58,0,0,0,4,3.111a1.6,1.6,0,0,0,3.2,0A1.58,1.58,0,0,0,5.6,1.555Z",
    transform: "translate(0 0.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorsblack);
export default __webpack_public_path__ + "static/media/operatorsblack.f16f2009.svg";
export { ForwardRef as ReactComponent };